/*
 * File: /src/store/modules/connectors.js
 * Created Date: Sunday May 12th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 12th May 2019 10:42:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import connectorService from '../../services/connectorService';

const state = {
  connectors: undefined
};

const getters = {
  getConnectors: state => {
    return state.connectors;
  },
};
const actions = {
  fetchConnectors({ commit }) {
    return connectorService.fetchByCompanyId()
      .then(r => {
        commit('setConnectors', r.data.data);
      });
  },
  unloadConnectors({ commit }) {
    commit('setConnectors', undefined);
  },
};
const mutations = {
  setConnectors(state, d) {
    state.connectors = d;
    // state.queues = Object.assign([], d);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
